import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import DashboardLayout from "@/components/feature/DashboardLayout";
import DashboardHome from "@/pages/dashboard/page";
import Login from "@/pages/login/page";
import Register from "@/pages/register/page";
import StorePage from "@/pages/store/page";
import MenuPage from "@/pages/menu/page";
import ProductFormPage from "@/pages/menu/form/page";
import BranchesPage from "@/pages/branches/page";
import BranchFormPage from "@/pages/branches/form/page";
import BranchDetailPage from "@/pages/branches/detail/page";
import EmployeesPage from "@/pages/employees/page";
import EmployeeNewPage from "@/pages/employees/new/page";
import EmployeeEditPage from "@/pages/employees/edit/page";
import OrdersPage from "@/pages/orders/page";
import OrderDetailPage from "@/pages/orders/detail/page";
import OrderInvoicePage from "@/pages/orders/detail/invoice/page";
import PosPage from "@/pages/pos/page";
import PosReceiptPage from "@/pages/pos/receipt/page";
import InvoicesPage from "@/pages/invoices/page";
import InvoiceDetailPage from "@/pages/invoices/detail/page";
import ReportsPage from "@/pages/reports/page";
import FinancialPage from "@/pages/financial/page";
import SettlePage from "@/pages/financial/settle/page";
import NotificationsPage from "@/pages/notifications/page";
import SettingsPage from "@/pages/settings/page";

const routes: RouteObject[] = [
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        index: true,
        element: <DashboardHome />,
      },
      {
        path: "store",
        element: <StorePage />,
      },
      {
        path: "menu",
        element: <MenuPage />,
      },
      {
        path: "menu/new",
        element: <ProductFormPage />,
      },
      {
        path: "menu/:id/edit",
        element: <ProductFormPage />,
      },
      {
        path: "branches",
        element: <BranchesPage />,
      },
      {
        path: "branches/new",
        element: <BranchFormPage />,
      },
      {
        path: "branches/:id/edit",
        element: <BranchFormPage />,
      },
      {
        path: "branches/:id",
        element: <BranchDetailPage />,
      },
      {
        path: "employees",
        element: <EmployeesPage />,
      },
      {
        path: "employees/new",
        element: <EmployeeNewPage />,
      },
      {
        path: "employees/:id/edit",
        element: <EmployeeEditPage />,
      },
      {
        path: "orders",
        element: <OrdersPage />,
      },
      {
        path: "orders/:id",
        element: <OrderDetailPage />,
      },
      {
        path: "orders/:id/invoice",
        element: <OrderInvoicePage />,
      },
      {
        path: "pos",
        element: <PosPage />,
      },
      {
        path: "pos/receipt",
        element: <PosReceiptPage />,
      },
      {
        path: "invoices",
        element: <InvoicesPage />,
      },
      {
        path: "invoices/:id",
        element: <InvoiceDetailPage />,
      },
      {
        path: "reports",
        element: <ReportsPage />,
      },
      {
        path: "financial",
        element: <FinancialPage />,
      },
      {
        path: "financial/settle",
        element: <SettlePage />,
      },
      {
        path: "notifications",
        element: <NotificationsPage />,
      },
      {
        path: "settings",
        element: <SettingsPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;